import { Component, input, Input, model, OnInit, SimpleChanges } from '@angular/core';
import { EIcon } from '../../types/iconType';
import { Types } from 'shared-lib';
import { CommonModule } from '@angular/common';
import { EComponentSize } from '../../types';
import { helper } from '../../../public-api';

@Component({
  selector: 'ui-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnInit {
  icon = model<EIcon>(EIcon.Bell);
  size = model<EComponentSize>(EComponentSize.Medium);
  color = model<Types.EAlert>(Types.EAlert.DARK);
  fill = input(false);

  stroke = this.fill() ? '1' : '2';
  darkMode = false;

  ngOnInit(): void {
    this.darkMode = helper.Functions.isDarkMode();
  }

  get fillInput(): string {
    return this.fill() ? 'currentColor' : 'none';
  }

  getSize(): string {
    const sizeClasses: Record<EComponentSize, string> = {
      [EComponentSize.Small]: 'w-4 h-4',
      [EComponentSize.Medium]: 'w-6 h-6',
      [EComponentSize.Large]: 'w-8 h-8',
      [EComponentSize.ExtraLarge]: 'w-10 h-10',
    };

    return sizeClasses[this.size()] || '';
  }

  getClass() {
    const baseClass = this.getSize();

    switch (this.color()) {
      case Types.EAlert.INFO:
        return `${baseClass} text-blue-500`;
      case Types.EAlert.DANGER:
        return `${baseClass} text-red-500`;
      case Types.EAlert.SUCCESS:
        return `${baseClass} text-green-500`;
      case Types.EAlert.WARNING:
        return `${baseClass} text-yellow-500`;
      case Types.EAlert.DARK:
      case Types.EAlert.LIGHT:
        if (this.darkMode) {
          return `${baseClass} text-white`;
        }
        return `${baseClass} text-black`;
      default:
        return `${baseClass}`;
    }
  }
}
